import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { getMessaging, getToken } from 'firebase/messaging';
import { Observable, Subject, map } from 'rxjs';
import { environment } from '../../../../../environments/environment'
@Injectable({
  providedIn: 'root'
})
export class AuthApiService {

  private userChanged$ = new Subject<void>();
  readonly userChanged = this.userChanged$.asObservable();
  notifyUserChanged(): void {
    this.userChanged$.next();
  }

  // messaging = getMessaging();
  private extractData(res: Response) {
    const body = res;
    return body || <any>{};
  }

  private baseUrl = environment.baseUrl;
  private firebase = environment.firebase;

  constructor(private http: HttpClient) {

  }

  // Get FCM token based on user permision
  async getFCMToken() {
    // return await getToken(this.messaging,
    //   { vapidKey: this.firebase.vapidKey }).then(
    //     (currentToken: any) => {
    //       if (currentToken) {
    //         return currentToken;
    //       } else {
    //         console.log('No registration token available. Request permission to generate one.');
    //         return "";
    //       }
    //     }).catch((err: any) => {
    //       console.log('An error occurred while retrieving token. ', err);
    //       return "";
    //     });
    return "";
  }


  login(body: any): Observable<any> {
    const requestUrl = this.baseUrl + '/admin/login/';
    return this.http.post<any>(requestUrl, body).pipe(map(this.extractData));
  }


  loginOTP(body: any): Observable<any> {
    const requestUrl = this.baseUrl + '/admin/login_otp/';
    return this.http.post<any>(requestUrl, body).pipe(map(this.extractData));
  }


  // Forget password
  forgetPassword(body: any): Observable<any> {
    const requestUrl = this.baseUrl + '/admin/reset_link/';
    return this.http.post<any>(requestUrl, body).pipe(map(this.extractData));
  }

  // New password update
  newPasswordUpdate(body: any): Observable<any> {
    const requestUrl = this.baseUrl + '/admin/reset_password/';
    return this.http.put<any>(requestUrl, body).pipe(map(this.extractData));
  }


    // New password create
    createPassword(body: any): Observable<any> {
      const requestUrl = this.baseUrl + '/admin/create_password/';
      return this.http.put<any>(requestUrl, body).pipe(map(this.extractData));
    }

    
  // validateRestLink update
  validateRestLink(body: any): Observable<any> {
    const requestUrl = this.baseUrl + '/admin/validate_link/'+body.type;
    return this.http.post<any>(requestUrl, body).pipe(map(this.extractData));
  }


  signUp(body: any): Observable<any> {
    const requestUrl = this.baseUrl + '/admin/signup/';
    return this.http.post<any>(requestUrl, body).pipe(map(this.extractData));
  }

  signUpOtp(body: any): Observable<any> {
    const requestUrl = this.baseUrl + '/admin/signup-otp/';
    return this.http.post<any>(requestUrl, body).pipe(map(this.extractData));
  }

  otpAuthentification(body: any): Observable<any> {
    const requestUrl = this.baseUrl + '/admin/otp-auth/';
    return this.http.post<any>(requestUrl, body).pipe(map(this.extractData));
  }

  getCountryCode(): Observable<any> {
    const requestUrl = this.baseUrl + '/country/';
    return this.http.get<any>(requestUrl).pipe(map(this.extractData));
  }

  validation(obj: { [x: string]: string | any[]; }, requiredFields: any[]) {
    let validationStatus = {};
    requiredFields.forEach(field => {
      validationStatus[field] = !obj[field] || (Array.isArray(obj[field]) && obj[field].length === 0);
    });
    return validationStatus;
  }

  checkUserExist(body: any): Observable<any> {
    const requestUrl = this.baseUrl + '/admin/checker/' + (body.type ? body.type : 'mail');
    return this.http.put<any>(requestUrl, body).pipe(map(this.extractData));
  }


  getAppInfo(domain): Observable<any> {
    const params = new HttpParams();
    const requestUrl = this.baseUrl + '/appInfo/' + domain;
    return this.http.get<any>(requestUrl, { params }).pipe(map(this.extractData));
  }


}
